import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './components/App';
import { ThemeProvider } from './theme-context';

import "@amzn/meridian-tokens/base/font/amazon-ember.css";

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </React.StrictMode>
);
